# A proposal the logged reviewer can review, with its content (the link_schedule v1 snapshot), to
# open the assignation editor for its review.
query assignmentProposalForReview(
  $scenarioId: ID!
  $originId: ID!
  $linkId: ID!
  $proposalId: ID!
) {
  cube(scenarioId: $scenarioId, originId: $originId) {
    assignmentProposalForReview(linkId: $linkId, proposalId: $proposalId) {
      errorCode
      content
      proposal {
        id
        state
        status
        submittedAt
        comment
        createdBy {
          username
          name
          lastName
          __typename
        }
        requestedReviewers {
          username
          name
          lastName
          __typename
        }
        allowedActions
        __typename
      }
      __typename
    }
    __typename
  }
}
